import * as React from "react";
import { BtnState } from "../interfaces/App";
import icons from "../../assets/icons/icons.svg";

export enum IconType {
    none    = "none",
    progress= "progress",
    globe	= "globe",
    login	= "login",
    check	= "check",
    register= "register",
    search	= "search",
    infoCircle	= "infoCircle",
    pencil	= "pencil",
    key	    = "key",
    lock	= "lock",
    save	= "save",
    asterisk= "asterisk",
    user	= "user",
    logout	= "logout",
    locationArrow	= "locationArrow",
    upload	= "upload",
    trash	= "trash",
    arrowRight	= "arrowRight",
    times	= "times",
    eye	    = "eye",
    eyeOff	= "eyeOff",
    cloud	= "cloud",
    back	= "back",
    burger  = "burger"
};

interface IOwnProps {
    icon: IconType;
    className?: string;
    // hint?: string;
    state: BtnState;
}

function Icon(props: IOwnProps): React.JSX.Element {
    const iconPath = `${icons}#${props.state === BtnState.wait ? IconType.progress : props.icon}`;
    const className = `icon ${props.state === BtnState.wait ? "spin" : props.state === BtnState.inactive ? "icon--inactive" : props.className ? props.className : ""}`; 
    return (
        <svg 
            aria-hidden= "true" 
            focusable= "false" 
            xmlns= "http://www.w3.org/2000/svg" 
            viewBox= "0 0 512 512"
            className={className}
        >
            <use href={iconPath} className={className} />
        </svg>
    );
}

export default (Icon);
